import { NotFound as NotFoundIcon } from '@instamenu/ui-icons';
import React from 'react';
import { responsiveSvg } from './not-found.css';
import { CenteredBox } from '../box/box';
import { Text } from '../text/text';
import { themeVars } from '@instamenu/ui-vanilla-extract';

export const NotFound = ({ message }: { message?: React.ReactNode }) => {
  return (
    <CenteredBox style={{ gap: '2rem', height: '100dvh', padding: themeVars.pad[12] }}>
      <NotFoundIcon className={responsiveSvg} />
      {message && (
        <Text css={{ textAlign: 'center' }} variant="subtitle1">
          {message}
        </Text>
      )}
    </CenteredBox>
  );
};
